import { FC } from 'react';
import { Flex, Text, Skeleton } from '@chakra-ui/react';
import ArcadeToken from '../Icons/ArcadeToken';
import { formatNumber } from '../../helpers/numbers';
export interface CbTokenBalanceProps {
  color?: string;
  fontWeight?: string;
  isPending: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  tokenBalance: number;
  withSign?: boolean;
}
export const CbTokenBalance: FC<CbTokenBalanceProps> = ({
  color = 'text.secondary',
  fontWeight = 'semibold',
  isPending,
  size = 'md',
  tokenBalance,
  withSign = false
}) => {
  const tokenSize = size === 'sm' || size == 'xs' ? ['16px', '20px'] : ['20px', '24px'];
  return <Flex alignItems="center" data-sentry-element="Flex" data-sentry-component="CbTokenBalance" data-sentry-source-file="CbTokenBalance.tsx">
      <ArcadeToken marginRight={1} paddingTop="1px" width={tokenSize} height={tokenSize} data-sentry-element="ArcadeToken" data-sentry-source-file="CbTokenBalance.tsx" />
      {isPending ? <Skeleton data-testid="skeleton" height={6} width={20} /> : <Text color={color} fontSize={size} fontWeight={fontWeight}>
          {formatNumber(tokenBalance, withSign)}
        </Text>}
    </Flex>;
};